
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiComMessageImportantGoogle as ObiComMessageImportantGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-com-message-important-google.js';
 
 
 

 
 export const ObiComMessageImportantGoogle = createComponent({
   react: React,
   tagName: 'obi-com-message-important-google',
   elementClass: ObiComMessageImportantGoogleElement,
   events: {
     
   }
  });
 
 